import { render } from "./Preloading.vue?vue&type=template&id=338c7140&scoped=true"
const script = {}

import "./Preloading.vue?vue&type=style&index=0&id=338c7140&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-338c7140"]])

export default __exports__